export default __webpack_public_path__ + "static/media/zapierIcon.6d6d6c48.svg";